import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

import {
  DEFAULT_BUTTON_CARD_CHIP_COLOR,
  DEFAULT_BUTTON_CARD_CHIP_SHAPE,
  DEFAULT_BUTTON_CARD_CHIP_SIZE,
  DEFAULT_BUTTON_CARD_CHIP_TYPE,
  MunilyButtonCardChipConfig,
} from './button-card.types';

@Component({
  selector: 'common-button-card',
  templateUrl: './button-card.component.html',
  styleUrls: ['./button-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonCardComponent implements OnChanges {
  @Input() title = '';
  @Input() description = '';
  /** When set, renders `app-info-chip` in the header row. */
  @Input() chip?: MunilyButtonCardChipConfig | null;
  @Input() selected = false;
  @Input() disabled = false;

  @Output() cardClick = new EventEmitter<void>();

  rootClasses = 'munily-button-card';

  readonly defaultChipColor = DEFAULT_BUTTON_CARD_CHIP_COLOR;
  readonly defaultChipType = DEFAULT_BUTTON_CARD_CHIP_TYPE;
  readonly defaultChipSize = DEFAULT_BUTTON_CARD_CHIP_SIZE;
  readonly defaultChipShape = DEFAULT_BUTTON_CARD_CHIP_SHAPE;

  ngOnChanges(_changes: SimpleChanges): void {
    this.syncRootClasses();
  }

  get hasChip(): boolean {
    return !!this.chip?.label?.trim();
  }

  get hasDescription(): boolean {
    return !!this.description?.trim();
  }

  onActivate(): void {
    if (this.disabled) return;
    this.cardClick.emit();
  }

  onKeydown(event: KeyboardEvent): void {
    if (this.disabled) return;
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.cardClick.emit();
    }
  }

  private syncRootClasses(): void {
    const classes = ['munily-button-card'];
    if (this.selected) {
      classes.push('munily-button-card--selected');
    }
    if (this.disabled) {
      classes.push('munily-button-card--disabled');
    }
    this.rootClasses = classes.join(' ');
  }
}
